import {inlineError, tracer} from '@s-ui/decorators/lib/index.js'
import {UseCase} from '@s-ui/domain'

import {StringSharedValueObject} from '../../shared/ValueObjects/StringSharedValueObject.js'
import {HTTPTransactionRepository} from '../Repositories/HTTPTransactionRepository.js'

/**
 * @implements UseCase
 */

class GetPaymentInitiatedTransactionsUseCase extends UseCase {
  #repository

  constructor({repository}) {
    super()
    this.#repository = repository
  }

  static create({config}) {
    return new GetPaymentInitiatedTransactionsUseCase({repository: HTTPTransactionRepository.create({config})})
  }

  @tracer({metric: 'GetPaymentInitiatedTransactionsUseCase#execute'})
  @inlineError
  async execute({tradeId}) {
    const requestVO = StringSharedValueObject.create({value: tradeId})

    const [error, response] = await this.#repository.getPaymentInitiated({tradeId: requestVO})

    if (error) throw error

    return response.isPaymentInitiated
  }
}

export const factory = GetPaymentInitiatedTransactionsUseCase.create
